import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    // Matches the Overview's chart block. The two differed by one spacing step, which
    // was drift rather than a decision.
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3)
  },
  heading: { marginBottom: theme.spacing(1) },
  chart: { width: '100%' }
}))

export default useStyles
